module.exports = __webpack_public_path__ + "static/Testeira_MaxiPack_4-be4c51a0c3a966cbe2a9e5ae2e279127.jpg";